import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { traceFunction } from '@core/datadog-server'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import {
  BRAND_SLUGS,
  brandPageFallbackStory,
  BrandSlugs,
} from './storyblok/data/fallback-json'
import { BrandPageStory } from './storyblok/storyblok'

const isDev = process.env.STAGE_NAME !== 'production'
const STORYBLOK_BFF_URL = readFromEnv(Env.StoryblokBFFComponent)

const isBrandSlug = (slug: string): slug is BrandSlugs =>
  BRAND_SLUGS.includes(slug as BrandSlugs)

const getStory = async (preview: boolean, slug: string) => {
  try {
    return await getStoryBySlug<BrandPageStory>(
      `landing/${slug}`,
      {
        version: preview || isDev ? 'draft' : 'published',
        resolve_relations: 'CarsCarousel.financeRepresentativeExample',
      },
      { strict: true, urlDomain: STORYBLOK_BFF_URL },
    )
  } catch {
    if (isBrandSlug(slug)) return brandPageFallbackStory[slug]
    return brandPageFallbackStory[BRAND_SLUGS[0]]
  }
}

const getStoryProps = async (slug: string, preview = false) => {
  const story = await getStory(preview, slug)

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: false,
      },
    },
    revalidate: 60,
  }
}

const getXpengStaticPropsfn: GetStaticProps = async ({ preview = false }) =>
  await getStoryProps('xpeng', preview)

export const getXpengStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getXpengStaticPropsfn,
)

const getBydStaticPropsfn: GetStaticProps = async ({ preview = false }) =>
  await getStoryProps('byd', preview)

export const getBydStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getBydStaticPropsfn,
)

const getJaecooStaticPropsfn: GetStaticProps = async ({ preview = false }) =>
  await getStoryProps('jaecoo', preview)

export const getJaecooStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getJaecooStaticPropsfn,
)

const getOmodaStaticPropsfn: GetStaticProps = async ({ preview = false }) =>
  await getStoryProps('omoda', preview)

export const getOmodaStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getOmodaStaticPropsfn,
)

const getCheryStaticPropsfn: GetStaticProps = async ({ preview = false }) =>
  await getStoryProps('chery', preview)

export const getCheryStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getCheryStaticPropsfn,
)

export type BrandPageProps = InferGetStaticPropsType<typeof getStoryProps>
